import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Weddingcarrenttalpune() {


const cardData = {
keyword: "Wedding Car Rental Pune",
headingDescription: "Ruturaj Enterprises provides comfortable and well-planned Wedding Car Rental Pune services for brides, grooms, families, relatives, wedding guests, and event organizers requiring convenient transportation during marriage functions and celebrations. Wedding cars can be arranged for bridal entry, groom transportation, family travel, guest transfers, hotel-to-venue movement, airport pickups, reception travel, and other wedding-related journeys across Pune. Travelers can choose luxury, sedan, SUV, AC, affordable, driver-operated, guest, marriage function, event, and taxi transportation options according to the occasion, passenger count, vehicle preference, luggage, venue location, and schedule. Dedicated wedding transportation helps families coordinate important movements between homes, hotels, temples, banquet halls, resorts, reception venues, and other locations while keeping the travel arrangements organized.",
topPlaces: [
{
title: "Koregaon Park",
description: "Koregaon Park is a popular Pune locality with premium hotels, restaurants, event spaces, and venues that can host wedding-related gatherings and celebrations. Private wedding cars can be arranged for guests, family members, brides, grooms, and VIP visitors traveling between hotels, homes, and nearby function venues."
},
{
title: "Viman Nagar",
description: "Viman Nagar has numerous hotels, commercial establishments, and event facilities and is also conveniently connected with Pune Airport. Wedding transportation can support airport pickups, guest transfers, hotel movements, and scheduled travel to marriage venues for families arranging celebrations in and around Pune."
},
{
title: "Baner",
description: "Baner is a prominent residential and commercial locality with hotels, banquet spaces, restaurants, and event facilities suitable for wedding-related activities. Dedicated cars can help coordinate transportation for bridal parties, family members, guests, and event teams traveling between accommodation and wedding venues."
},
{
title: "Kharadi",
description: "Kharadi is a growing business and residential destination with hotels and event spaces that may accommodate wedding functions and guest stays. Private wedding car arrangements provide convenient transportation for guests arriving from different parts of Pune and for scheduled movement between hotels, homes, and function venues."
},
{
title: "Aundh",
description: "Aundh offers a combination of residential neighborhoods, hotels, restaurants, and event facilities that can form part of a wedding itinerary. Wedding cars can be organized for family transportation, bridal and groom movements, guest transfers, and travel between different ceremony locations."
},
{
title: "Shivajinagar",
description: "Shivajinagar is a centrally located part of Pune with convenient access to residential areas, hotels, transportation points, and event destinations. Wedding transportation from this area can help guests and family members travel comfortably to marriage functions while accommodating planned pickup and drop timings."
},
{
title: "Pune Airport",
description: "Pune Airport is an important arrival point for wedding guests, relatives, and family members traveling from other cities for marriage celebrations. Dedicated wedding cars can be coordinated around flight schedules to provide direct transportation from the airport to hotels, homes, banquet venues, and other wedding locations."
},
{
title: "Magarpatta City",
description: "Magarpatta City and its surrounding areas include hotels, residential communities, restaurants, and commercial facilities that can be part of wedding travel arrangements. Private cars can support guest transportation and family movement between accommodation, event locations, reception venues, and other planned destinations."
},
{
title: "Pimpri-Chinchwad",
description: "Pimpri-Chinchwad is a major urban region with residential communities, hotels, banquet facilities, and event destinations used for family celebrations and marriage functions. Wedding car arrangements can help coordinate guests and relatives traveling from this region to venues across Pune and surrounding areas."
},
{
title: "Lonavala",
description: "Lonavala is a popular destination for resort weddings, family celebrations, receptions, and private events located away from central Pune. Wedding transportation can be planned for couples, relatives, guests, and event participants traveling between Pune, hotels, resorts, and wedding venues in the hill-station region."
}
],
services: [
{
name: "Wedding Car Rental Pune",
description: "Wedding Car Rental Pune provides private vehicle arrangements for brides, grooms, families, relatives, guests, and event organizers during wedding celebrations. Cars can be scheduled for ceremonies, receptions, hotel transfers, airport pickups, venue movements, and other important occasions according to the wedding itinerary."
},
{
name: "Wedding Car Hire Pune",
description: "Wedding Car Hire Pune is suitable for couples and families requiring dedicated transportation for marriage ceremonies, receptions, pre-wedding functions, and guest movements. Vehicle selection can be planned according to the event style, passenger requirements, travel distance, schedule, and preferred comfort level."
},
{
name: "Wedding Car Booking Pune",
description: "Wedding Car Booking Pune allows families to organize private transportation in advance for important wedding-day movements and guest requirements. Cars can be scheduled around ceremony timings, hotel stays, venue transfers, airport arrivals, and other locations included in the wedding program."
},
{
name: "Marriage Car Rental Pune",
description: "Marriage Car Rental Pune provides transportation options for couples, families, relatives, and guests attending marriage functions across Pune. Rental arrangements can support bridal and groom travel, guest transfers, venue changes, reception transportation, and other scheduled movements throughout the celebration."
},
{
name: "Marriage Car Hire Pune",
description: "Marriage Car Hire Pune offers privately arranged cars for wedding ceremonies, receptions, family functions, and guest transportation. Vehicle requirements can be coordinated around the number of passengers, luggage, event schedule, venue locations, and the preferred type of car for different parts of the celebration."
},
{
name: "Bridal Car Rental Pune",
description: "Bridal Car Rental Pune is designed for transportation requirements involving the bride before, during, and after the wedding ceremony. A dedicated car can be arranged for travel between the bride's residence, hotel, ceremony venue, photography locations, reception venue, and other planned destinations."
},
{
name: "Luxury Wedding Car Pune",
description: "Luxury Wedding Car Pune provides a premium transportation option for brides, grooms, families, and special wedding guests who prefer an elevated travel experience. Luxury-oriented cars can be considered for bridal arrivals, groom transportation, receptions, photography sessions, VIP guests, and special wedding occasions."
},
{
name: "Wedding Sedan Rental Pune",
description: "Wedding Sedan Rental Pune offers a practical and comfortable car option for couples, family members, and individual wedding guests. Sedans can be arranged for bridal and groom travel, hotel transfers, airport transportation, ceremony visits, and other wedding movements requiring a dedicated private vehicle."
},
{
name: "Wedding SUV Rental Pune",
description: "Wedding SUV Rental Pune is suitable for families, groups, and passengers who require additional cabin and luggage space during wedding celebrations. SUVs can support guest transfers, family travel, airport pickups, venue movements, and longer wedding-related journeys involving multiple passengers."
},
{
name: "Wedding Guest Car Rental Pune",
description: "Wedding Guest Car Rental Pune provides dedicated transportation for relatives, friends, colleagues, and invited guests attending marriage functions. Cars can be scheduled between airports, railway stations, hotels, residences, ceremony venues, reception halls, and other destinations according to guest arrival and event timings."
},
{
name: "Groom Car Rental Pune",
description: "Groom Car Rental Pune provides a dedicated vehicle for the groom's transportation during wedding ceremonies, processions, photography sessions, receptions, and related functions. The arrangement can be coordinated around the groom's schedule and the locations included in the overall wedding itinerary."
},
{
name: "Bride Car Hire Pune",
description: "Bride Car Hire Pune offers private transportation for the bride traveling between her residence, hotel, wedding venue, reception location, and other planned destinations. A dedicated car helps families coordinate important movements around ceremony timings and provides convenient travel throughout the wedding schedule."
},
{
name: "AC Wedding Car Pune",
description: "AC Wedding Car Pune provides air-conditioned transportation for couples, families, and guests who prefer a comfortable cabin during wedding-related travel. This option is useful for movements between hotels, homes, ceremony venues, reception halls, airports, and other destinations included in the event itinerary."
},
{
name: "Wedding Car with Driver Pune",
description: "Wedding Car with Driver Pune provides a convenient chauffeur-driven transportation arrangement so couples and families can focus on their wedding activities instead of managing the vehicle. Driver-operated cars can be scheduled for ceremonies, receptions, guest transfers, airport pickups, and multiple venue movements."
},
{
name: "Wedding Transportation Pune",
description: "Wedding Transportation Pune supports broader travel requirements involving brides, grooms, families, relatives, guests, and event teams during marriage celebrations. Transportation can be coordinated across homes, hotels, airports, railway stations, banquet halls, temples, resorts, and reception venues according to the event schedule."
},
{
name: "Wedding Event Car Rental Pune",
description: "Wedding Event Car Rental Pune provides private cars for different functions connected with a marriage celebration, including ceremonies, receptions, engagement events, family gatherings, and related programs. Vehicle scheduling can be arranged around event timings, guest movement, venue locations, and the number of people requiring transportation."
},
{
name: "Affordable Wedding Car Rental Pune",
description: "Affordable Wedding Car Rental Pune offers a practical transportation choice for families looking to organize wedding travel while maintaining a planned budget. Cars can be selected according to passenger requirements and scheduled for guest transfers, family movements, venue travel, airport pickups, and other important wedding journeys."
},
{
name: "Wedding Car Booking Service Pune",
description: "Wedding Car Booking Service Pune helps families coordinate private vehicles for different stages of their marriage celebrations. Booking arrangements can cover bridal transportation, groom travel, guest movement, hotel transfers, airport pickups, reception transportation, and other scheduled journeys included in the wedding plan."
},
{
name: "Marriage Function Car Hire Pune",
description: "Marriage Function Car Hire Pune is suitable for transportation requirements connected with ceremonies, receptions, engagement functions, family gatherings, and other marriage-related events. Dedicated cars can be organized according to venue locations, passenger capacity, function timings, and the specific movement requirements of the family."
},
{
name: "Wedding Guest Transportation Pune",
description: "Wedding Guest Transportation Pune provides organized private travel for relatives, friends, colleagues, and invited guests attending marriage celebrations. Transportation can be coordinated between airports, railway stations, hotels, residences, ceremony venues, reception halls, and other locations to make guest movement easier throughout the event."
},
{
name: "Luxury Marriage Car Pune",
description: "Luxury Marriage Car Pune offers premium private transportation for couples, family members, VIP guests, and special wedding occasions where an enhanced vehicle experience is preferred. It can be arranged for bridal and groom travel, wedding arrivals, receptions, photography sessions, and important family movements."
},
{
name: "Wedding Taxi Service Pune",
description: "Wedding Taxi Service Pune provides flexible private transportation for couples, families, guests, and event organizers during marriage celebrations. The service can cover local transfers, venue travel, hotel transportation, airport pickups, guest movements, ceremonies, receptions, and other wedding-related journeys based on the planned schedule."
}
],
tableData: [
["Wedding Car Rental Pune", "Private wedding car arrangements for couples, families, guests, ceremonies, receptions, and venue transfers."],
["Wedding Car Hire Pune", "Dedicated car hire for marriage ceremonies, receptions, family travel, and wedding guest movements."],
["Wedding Car Booking Pune", "Advance wedding car booking for bridal travel, groom transportation, guest transfers, and event movements."],
["Marriage Car Rental Pune", "Marriage function car rental for couples, relatives, families, guests, and scheduled wedding transportation."],
["Marriage Car Hire Pune", "Private car hire for ceremonies, receptions, family functions, hotel transfers, and guest travel."],
["Bridal Car Rental Pune", "Dedicated bridal transportation for residence, hotel, ceremony venue, reception, and photography locations."],
["Luxury Wedding Car Pune", "Premium wedding car option for bridal arrivals, groom travel, VIP guests, receptions, and special occasions."],
["Wedding Sedan Rental Pune", "Comfortable sedan rental for couples, family members, individual guests, and wedding venue transfers."],
["Wedding SUV Rental Pune", "SUV rental option providing additional passenger and luggage space for families and wedding groups."],
["Wedding Guest Car Rental Pune", "Private guest transportation between airports, hotels, residences, railway stations, and wedding venues."],
["Groom Car Rental Pune", "Dedicated groom transportation for ceremonies, processions, photography sessions, and receptions."],
["Bride Car Hire Pune", "Private bride car hire for wedding venues, hotels, residences, receptions, and planned event movements."],
["AC Wedding Car Pune", "Air-conditioned wedding car option for comfortable transportation during marriage functions."],
["Wedding Car with Driver Pune", "Chauffeur-driven wedding car service for couples, families, guests, ceremonies, and multiple venue transfers."],
["Wedding Transportation Pune", "Comprehensive transportation support for brides, grooms, families, guests, and wedding event teams."],
["Wedding Event Car Rental Pune", "Private car rental for wedding ceremonies, receptions, engagement functions, family gatherings, and events."],
["Affordable Wedding Car Rental Pune", "Budget-conscious wedding car rental for families requiring practical event and guest transportation."],
["Wedding Car Booking Service Pune", "Wedding booking service covering bridal, groom, family, guest, hotel, airport, and venue transportation."],
["Marriage Function Car Hire Pune", "Private cars for ceremonies, receptions, engagement functions, family gatherings, and marriage events."],
["Wedding Guest Transportation Pune", "Organized private transportation for relatives, friends, colleagues, and invited wedding guests."],
["Luxury Marriage Car Pune", "Premium marriage car transportation for couples, VIP guests, bridal arrivals, receptions, and special functions."],
["Wedding Taxi Service Pune", "Flexible wedding taxi service for local transfers, venue travel, airport pickups, hotel movements, and guest transportation."]
],
whychoose: [
{
WhyChooseheading: "Dedicated Wedding-Day Transportation",
WhyChoosedescription: "Wedding schedules often involve several locations and closely planned timings, making dedicated transportation useful for couples and families. Private cars can be coordinated for ceremonies, receptions, hotel transfers, airport pickups, family movements, photography sessions, and other important parts of the celebration."
},
{
WhyChooseheading: "Bridal and Groom Travel Support",
WhyChoosedescription: "The bride and groom may need transportation between homes, hotels, ceremony venues, reception locations, and photography destinations throughout the wedding day. Dedicated cars allow these movements to be organized around the couple's schedule while providing a private and comfortable travel arrangement."
},
{
WhyChooseheading: "Convenient Guest Transfers",
WhyChoosedescription: "Relatives and invited guests may arrive from different cities and require transportation between airports, railway stations, hotels, residences, and wedding venues. Private guest cars can be scheduled around arrival times and event timings to make movement between these locations easier to coordinate."
},
{
WhyChooseheading: "Multiple Vehicle Choices",
WhyChoosedescription: "Wedding transportation requirements can vary depending on whether the vehicle is intended for the couple, family members, individual guests, or larger groups. Sedan, SUV, AC, luxury, affordable, and driver-operated options provide flexibility for selecting transportation according to passenger capacity and event requirements."
},
{
WhyChooseheading: "Chauffeur-Driven Convenience",
WhyChoosedescription: "A car with a dedicated driver allows couples and family members to concentrate on wedding activities rather than handling navigation, parking, or vehicle management. Driver-operated transportation can be scheduled for ceremonies, receptions, hotel transfers, guest movements, and multiple venue changes during the event."
},
{
WhyChooseheading: "Suitable for Multiple Functions",
WhyChoosedescription: "Marriage celebrations may include engagement programs, traditional ceremonies, receptions, family gatherings, and other events held at different times or venues. Wedding car arrangements can be planned around each function so transportation remains available for the specific movements required throughout the celebration."
},
{
WhyChooseheading: "Airport and Hotel Connectivity",
WhyChoosedescription: "Wedding guests and relatives frequently require transportation between airports, railway stations, hotels, homes, and event venues. Private cars provide direct connectivity for these movements while allowing pickup and drop arrangements to be coordinated around flight schedules, check-in times, ceremony timings, and guest requirements."
},
{
WhyChooseheading: "Planned Wedding Travel Coordination",
WhyChoosedescription: "Ruturaj Enterprises can organize wedding transportation around the event's passenger count, vehicle requirements, pickup locations, venue addresses, timings, luggage, and preferred comfort category. This makes private car arrangements suitable for couples, families, guests, and event organizers managing multiple wedding-related journeys across Pune and nearby destinations."
}
]
};















const faqData = [
{
question: "How can I book a wedding car rental in Pune?",
answer: "Wedding car rental in Pune can be arranged by sharing the wedding date, pickup and drop locations, event timings, number of passengers, and preferred vehicle type. Ruturaj Enterprises can coordinate transportation for the bride, groom, family members, guests, and other wedding-related travel requirements."
},
{
question: "What types of cars are available for wedding rental in Pune?",
answer: "The choice of wedding vehicle depends on the event schedule, number of passengers, luggage, and desired comfort. Sedan cars, Ertiga, SUV, Innova, and Innova Crysta options can be considered for different wedding transportation needs, including individual travel and family or guest transfers."
},
{
question: "Can I rent a car for the bride and groom in Pune?",
answer: "A dedicated rental car can be arranged for bride and groom transportation between the residence, wedding venue, reception location, hotel, and other planned destinations. Vehicle selection can be discussed according to the couple's itinerary, event timings, and preferred level of comfort."
},
{
question: "Can wedding cars be booked for guests in Pune?",
answer: "Wedding transportation can also be organized for family members and guests traveling between hotels, railway stations, airports, homes, and wedding venues. Multiple cars can be planned when guests are arriving from different locations or when transportation is required at different times."
},
{
question: "Can I book wedding car rental for the entire wedding day?",
answer: "Full-day wedding transportation can be planned when vehicles are needed for several ceremonies, venue transfers, guest movement, photography locations, or reception activities. The schedule can be shared in advance so Ruturaj Enterprises can coordinate the vehicle requirement around the day's itinerary."
},
{
question: "Can I hire an Innova Crysta for a wedding in Pune?",
answer: "An Innova Crysta can be considered for families, VIP guests, relatives, or wedding groups looking for additional cabin space and comfortable seating. The vehicle can be arranged according to the number of passengers, luggage, event schedule, and locations involved in the wedding program."
},
{
question: "Is wedding car rental available for airport and railway station pickup?",
answer: "Wedding guests arriving in Pune by flight or train can use private car transportation for transfers to hotels, residences, or wedding venues. Pickup arrangements can be coordinated according to arrival timings, passenger numbers, luggage, and the destination provided during booking."
},
{
question: "Can I book wedding cars for multiple locations in Pune?",
answer: "Multiple-location wedding transportation can be arranged for ceremonies taking place at different venues. The itinerary may include home pickups, hotels, wedding halls, banquet venues, reception locations, and other stops, allowing the vehicle schedule to be organized around the complete wedding program."
},
{
question: "How early should I book a wedding car rental in Pune?",
answer: "It is useful to discuss wedding transportation requirements in advance, particularly when several cars or specific vehicle types are needed on the same date. Providing the wedding date, event timings, passenger details, and locations early allows Ruturaj Enterprises to plan the required transportation more effectively."
},
{
question: "Why choose Ruturaj Enterprises for Wedding Car Rental Pune?",
answer: "Ruturaj Enterprises arranges wedding car transportation in Pune for bride and groom transfers, family travel, guest pickups, airport and railway station transfers, venue movement, and wedding events. Vehicle selection and scheduling can be coordinated according to the ceremony itinerary, passenger count, locations, and event timings."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Kunal Patil",
feedback:
"We needed cars for different wedding functions in Pune and arranged the transportation through Ruturaj Enterprises. The vehicles were planned around our ceremony timings and venue transfers, which made it easier for our family to manage the day's travel. The overall arrangement was comfortable and convenient.",
rating: 5
},
{
id: 2,
name: "Miss. Aishwarya Joshi",
feedback:
"For my cousin's wedding, we arranged guest transportation with Ruturaj Enterprises. Cars were required for moving relatives between the hotel, wedding venue, and other locations in Pune. Having the travel schedule organized in advance made the wedding transportation much easier for everyone.",
rating: 5
}
];








































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
        { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller on Rent", link: "Pune-to-Shirdi-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "Pune-to-Mahabaleshwar-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller", link: "Pune-to-Goa-Tempo-Traveller" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "Pune-to-Mumbai-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/6.jpg", text: "Pune to Konkan Tempo Traveller", link: "Pune-to-Konkan-Tempo-Traveller" },
        { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "Pune-to-Nashik-Tempo-Traveller-On-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller On Rent", link: "Pune-Darshan-Tempo-Traveller-On-Rent" },
        { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller on Rent", link: "13-Seater-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-Seater-Tempo-Traveller-on-Rent-in-Pune" },
        { place: "/images/keyword/12.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller on Rent in Pune", link: "26-Seater-Tempo-Traveller-on-Rent-in-Pune" },
        { place: "/images/keyword/14.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
        { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/16.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/18.jpg", text: "Bus Rentals For School Trips in Pune", link: "Bus-Rentals-For-School-Trips-in-Pune" },
        { place: "/images/keyword/19.jpg", text: "Bus booking for wedding in Pune", link: "Bus-booking-for-wedding-in-Pune" },
        { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage", link: "Bus-Booking-for-Marriage" },
        { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate Pune", link: "Bus-Service-for-Corporate-Pune" },
        { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "Bus-on-Rent-For-Event-in-Pune" },
        { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation", link: "Bus-Hire-for-Outstation" },
        { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "AC-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "Pune-Bus-Hire-Rental-Service" },
    ];













const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Wedding Car Rental Pune",
  "image": "https://ruturajenterprises.com/assets/images/wedding-car-rental-pune.webp",
  "description":
    "Wedding Car Rental Pune for comfortable and stylish transportation of brides, grooms, wedding guests, family members and relatives. Ruturaj Enterprises provides wedding car rental, hire and booking services with AC sedans, SUVs, luxury cars and comfortable vehicles suitable for marriage ceremonies, receptions, engagement functions, pre-wedding events, venue transfers and guest transportation. Flexible rental options make it convenient to arrange bridal cars, groom cars, guest vehicles and multiple cars for different wedding functions across Pune.",
  "brand": {
    "@type": "Brand",
    "name": "Ruturaj Enterprises"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://ruturajenterprises.com/wedding-car-rental-pune"
  }
};


    return (
        <div>
<Helmet>
  <title>
    Wedding Car Rental Pune | Wedding Car Hire Pune | +91 9763381382
  </title>

  <meta
    name="description"
    content="Wedding Car Rental Pune for brides, grooms, families and wedding guests. Hire AC sedans, SUVs and luxury cars for marriage functions, receptions, venue transfers and guest transportation with Ruturaj Enterprises."
  />

  <meta
    name="keywords"
    content="Wedding Car Rental Pune, Wedding Car Hire Pune, Wedding Car Booking Pune, Marriage Car Rental Pune, Marriage Car Hire Pune, Bridal Car Rental Pune, Luxury Wedding Car Pune, Wedding Sedan Rental Pune, Wedding SUV Rental Pune, Wedding Guest Car Rental Pune, Groom Car Rental Pune, Bride Car Hire Pune, AC Wedding Car Pune, AC Wedding Car Rental Pune, AC Wedding Car Hire Pune, Wedding Taxi Rental Pune, Wedding Taxi Hire Pune, Wedding Taxi Booking Pune, Marriage Taxi Rental Pune, Marriage Taxi Hire Pune, Marriage Taxi Booking Pune, Bridal Car Hire Pune, Bridal Car Booking Pune, Groom Car Hire Pune, Groom Car Booking Pune, Bride Car Rental Pune, Bride Car Booking Pune, Luxury Wedding Car Rental Pune, Luxury Wedding Car Hire Pune, Luxury Wedding Car Booking Pune, Premium Wedding Car Pune, Premium Wedding Car Rental Pune, Premium Wedding Car Hire Pune, Wedding Sedan Hire Pune, Wedding Sedan Booking Pune, Wedding SUV Hire Pune, Wedding SUV Booking Pune, Wedding Guest Taxi Pune, Wedding Guest Taxi Rental Pune, Wedding Guest Taxi Hire Pune, Wedding Guest Transportation Pune, Wedding Guest Car Hire Pune, Wedding Guest Car Booking Pune, Marriage Guest Car Rental Pune, Marriage Guest Car Hire Pune, Marriage Guest Car Booking Pune, Marriage Guest Transportation Pune, Wedding Family Car Rental Pune, Wedding Family Car Hire Pune, Wedding Family Transportation Pune, Wedding Couple Car Rental Pune, Wedding Couple Car Hire Pune, Bride Groom Car Rental Pune, Bride Groom Wedding Car Pune, Bridal Luxury Car Pune, Groom Luxury Car Pune, Bride Luxury Car Pune, Wedding Car with Driver Pune, Wedding Car Rental with Driver Pune, Wedding Car Hire with Driver Pune, Wedding Car for Marriage Function Pune, Wedding Car for Reception Pune, Wedding Car for Engagement Pune, Wedding Car for Pre Wedding Pune, Wedding Car for Wedding Ceremony Pune, Wedding Car for Marriage Ceremony Pune, Wedding Car for Reception Function Pune, Wedding Car for Wedding Venue Pune, Wedding Venue Transfer Car Pune, Wedding Guest Transfer Car Pune, Wedding Pickup Drop Car Pune, Marriage Pickup Drop Car Pune, Wedding Transportation Service Pune, Marriage Transportation Service Pune, Wedding Car Service Pune, Marriage Car Service Pune, Wedding Vehicle Rental Pune, Marriage Vehicle Rental Pune, Wedding Car Rental Service Pune, Wedding Car Hire Service Pune, Wedding Car Booking Service Pune, Marriage Car Rental Service Pune, Marriage Car Hire Service Pune, Marriage Car Booking Service Pune, Affordable Wedding Car Rental Pune, Wedding Car Near Me Pune, Marriage Car Rental Near Me Pune, Ruturaj Enterprises Wedding Car Rental Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <div
                className="ltn__breadcrumb-area ltn__breadcrumb-area-2 ltn__breadcrumb-color-white bg-overlay-theme-black-90 bg-image"
                style={{ backgroundImage: "url('/img/bg/9.jpg')" }}
            >
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="ltn__breadcrumb-inner ltn__breadcrumb-inner-2 justify-content-between">
                                <div className="section-title-area ltn__section-title-2">
                                    <h1 className="section-title white-color">
                                        {cardData.keyword}
                                    </h1>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </div>






















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/76.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Ruturaj Enterprises: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">

                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable /> */}

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Ruturaj Enterprises</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ruturaj Enterprises </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                {/* <FleetHighway /> */}
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919763381382" className="pc-call">+91 9763381382</a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919011051114" className="pc-call">+91 9011051114</a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919822697554" className="pc-call">+91 9822697554</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919763381382"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919763381382" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@ruturajenterprises.com" className="pc-email">
                                            booking@ruturajenterprises.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Ruturaj Enterprises</strong><br />

                                            Nandini Takle Nagar, Pune - Solapur Road Manjri Bk Hadapsar, Pune, Maharashtra 412307
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Weddingcarrenttalpune ;